/* eslint-disable no-nested-ternary */
import React from 'react';
import { PhaseChartVesselProps } from '../types';
import { getTestName } from '../../../utils/CommonFunctions';

function PhaseChartTable({ tableDetails, primaryColor, secondaryColor }: PhaseChartVesselProps) {
  const getProbeValue = () => {
    if (tableDetails?.Section === 1) {
      return tableDetails?.ProbeDiameter1;
    }
    if (tableDetails?.Section === 3) {
      return tableDetails?.ProbeDiameter3;
    }
    return tableDetails?.ProbeDiameter;
  };
  const getOd = () => {
    let od;
    if (tableDetails?.Section === 1) {
      od = tableDetails?.Od1;
    } else if (tableDetails?.Section === 3) {
      od = tableDetails?.Od3;
    } else {
      od = tableDetails?.Od;
    }

    if (od !== undefined && od !== null) {
      if (Number.isInteger(od)) {
        return Number(od).toFixed(2);
      }
      return od;
    }
    return '-';
  };
  return (
    <table className="bordered-table w100">
      <div
        className="tableAfterThickBorderStyle"
        style={{
          backgroundColor: primaryColor,
        }}
      />
      <div
        className="tableBeforeThickBorderStyle"
        style={{
          backgroundColor: primaryColor,
        }}
      />
      <tr>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          Material
        </td>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          Tube Type
        </td>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          OD
        </td>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          Wall
        </td>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          Test Type
        </td>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          Frequency
        </td>
        <td className="tableGreenHeading textCenter boldText" style={{ backgroundColor: secondaryColor }}>
          Probe Diameter
        </td>
      </tr>
      <tr>
        <td className="textCenter">{tableDetails.MaterialName}</td>
        <td className="textCenter">{tableDetails.TubeType}</td>
        <td className="textCenter">
          {getOd()}
          {/* {tableDetails?.Od !== undefined && tableDetails?.Od !== null
            ? (Number.isInteger(tableDetails.Od) ? Number(tableDetails.Od).toFixed(2) : tableDetails.Od)
            : '-'} */}
        </td>
        <td className="textCenter">{tableDetails.Wall}</td>
        <td className="textCenter">{getTestName(tableDetails.TestType)}</td>
        <td className="textCenter">{tableDetails.Frequency}</td>
        <td className="textCenter">{tableDetails?.IsMultiOffset ? getProbeValue() : tableDetails.ProbeDiameter}</td>
      </tr>
    </table>
  );
}

export default PhaseChartTable;
